<script setup>
import {computed} from 'vue'

const props = defineProps({
    previousConference: {
        type: Object,
        required: true,
    },
})

const primaryVideo = computed(() => {
    if (!props.previousConference?.videos?.length) {
        return null
    }

    return props.previousConference.videos[0]
})
</script>

<template>
    <div
        :class="primaryVideo
            ? 'grid gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(320px,560px)] lg:items-start'
            : 'mx-auto max-w-4xl'">
        <div :class="primaryVideo ? 'max-w-3xl mx-auto lg:mx-0' : 'mx-auto max-w-3xl text-center'">
            <div>
                <h2 class="font-heading text-3xl sm:text-4xl mt-2 mb-6 uppercase text-slate-900">
                    {{ previousConference.date }}
                </h2>
            </div>

            <div
                v-if="previousConference.overview"
                class="text-lg leading-8 text-justify text-slate-700">
                <p
                    v-for="(paragraph, paragraphIndex) in previousConference.overview.split('\n').filter(Boolean)"
                    :key="paragraphIndex"
                    class="mt-5 first:mt-0">
                    {{ paragraph }}
                </p>
            </div>
        </div>

        <div v-if="primaryVideo" class="space-y-4 lg:pt-4">
            <div class="overflow-hidden rounded-md border border-slate-200 bg-slate-950 shadow-lg">
                <video class="h-full w-full" controls preload="metadata">
                    <source :src="primaryVideo.file" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </div>

            <div class="px-2">
                <h3 class="font-heading text-xl text-slate-900">
                    {{ primaryVideo.title }}
                </h3>
            </div>
        </div>
    </div>
</template>

<style scoped></style>
